/**
 * POP-10 shop mega menu overlay (synced with theme desktop navigation)
 */
(function () {
    const OVERLAY_CLASS = 'shop-popeiamission-mega-overlay';
    const OVERLAY_VISIBLE_CLASS = 'shop-popeiamission-mega-overlay--visible';
    const SHOP_ITEM_SELECTOR = '.header__linklist-item[data-item-title="Shop"]';
    const MEGA_MENU_SELECTOR = '.mega-menu--shop-popeiamission';
  
    function getOverlay() {
      let overlay = document.querySelector(`.${OVERLAY_CLASS}`);
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = OVERLAY_CLASS;
        document.body.insertBefore(overlay, document.body.firstChild);
      }
      return overlay;
    }
  
    function initShopMegaMenuOverlay() {
      const navigation = document.querySelector('desktop-navigation');
      const shopItem = document.querySelector(SHOP_ITEM_SELECTOR);
      const megaMenu = shopItem?.querySelector(MEGA_MENU_SELECTOR);
      if (!navigation || !shopItem || !megaMenu) {
        return;
      }
  
      const overlay = getOverlay();
      const shopLink = shopItem.querySelector('.header__linklist-link');
      const menuControl = shopItem.querySelector('[aria-controls]');
  
      function showOverlay() {
        overlay.classList.add(OVERLAY_VISIBLE_CLASS);
        if (shopLink) {
          shopLink.classList.add('shop-popeiamission-nav-active');
        }
      }
  
      function hideOverlay() {
        overlay.classList.remove(OVERLAY_VISIBLE_CLASS);
        if (shopLink) {
          shopLink.classList.remove('shop-popeiamission-nav-active');
        }
      }
  
      navigation.addEventListener('desktop-nav:dropdown:open', () => {
        if (!megaMenu.hasAttribute('hidden')) {
          showOverlay();
        }
      });
  
      navigation.addEventListener('desktop-nav:dropdown:close', () => {
        hideOverlay();
      });
  
      overlay.addEventListener('click', () => {
        megaMenu.setAttribute('hidden', '');
        if (menuControl) {
          menuControl.setAttribute('aria-expanded', 'false');
        }
        hideOverlay();
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initShopMegaMenuOverlay);
    } else {
      initShopMegaMenuOverlay();
    }
  
    document.addEventListener('shopify:section:load', initShopMegaMenuOverlay);
  
    function syncMobileMenuDrawerFromSection(event) {
      if (!window.Shopify?.designMode) {
        return;
      }
  
      const section = document.getElementById(`shopify-section-${event.detail.sectionId}`);
      const freshDrawer = section?.querySelector('#mobile-menu-drawer');
      const bodyDrawer = document.getElementById('mobile-menu-drawer');
  
      if (!freshDrawer || !bodyDrawer || freshDrawer === bodyDrawer) {
        return;
      }
  
      const wasOpen = bodyDrawer.hasAttribute('open');
      const replacement = freshDrawer.cloneNode(true);
      bodyDrawer.replaceWith(replacement);
      freshDrawer.remove();
  
      if (wasOpen) {
        document.getElementById('mobile-menu-drawer')?.setAttribute('open', '');
      }
    }
  
    document.addEventListener('shopify:section:load', syncMobileMenuDrawerFromSection);
  })();
  